import {
  IQuestionsData,
  ISetAnswersReduserParams
} from 'data/questionnaires/IQuestionAnswer'
import { merge } from 'lodash'
import { IReduxAction } from '../IReduxAction'
import ActionTypes from './types'

export interface IUserState {
  patients: any[]
  talentsChartData: any[]
  currentPatient: any
  errorCode: string
  errorMessage: string
  questionnarie_is_in_row: boolean
  questionsData: IQuestionsData
}

export const initState: IUserState = {
  patients: [],
  talentsChartData: [],
  currentPatient: null,
  errorCode: '',
  errorMessage: '',
  questionnarie_is_in_row: false,
  questionsData: {}
}

export default (state = initState, action: IReduxAction): IUserState => {
  const patients = [...state.patients]

  switch (action.type) {
    case ActionTypes.patient_add_begins:
      return state

    case ActionTypes.patient_add_success:
      return state

    case ActionTypes.patient_add_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case ActionTypes.get_all_patients_begins:
      return state

    case ActionTypes.get_all_patients_success:
      return {
        ...state,
        patients: action.payload.data.patients
      }

    case ActionTypes.get_all_patients_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case ActionTypes.get_current_patient_begins:
      return {
        ...state,
        currentPatient: null
      }

    case ActionTypes.get_current_patient_success:
      return {
        ...state,
        currentPatient: action.payload.data.patient
      }

    case ActionTypes.get_current_patient_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case ActionTypes.set_current_patient_begins:
      return {
        ...state,
        currentPatient: null
      }

    case ActionTypes.add_care_professional_success:
      const doctorId = action.payload.data.careProfessionalId
      return {
        ...state,
        currentPatient: {
          ...state.currentPatient,
          id_care_professional: doctorId
        }
      }
    case ActionTypes.set_current_patient_success: {
      const { currentPatient: patient } = action.payload.data
      const indexOfPatient = state.patients.findIndex(
        currPatient => currPatient.patientId === patient.patientId
      )
      const patientsArr = [...state.patients]
      patientsArr[indexOfPatient] = patient

      return {
        ...state,
        patients: patientsArr,
        currentPatient: patient
      }
    }
    case ActionTypes.update_current_patient:
      const index = state.patients.findIndex(
        child => child.patientId === state.currentPatient.patientId
      )
      const newCurrentPatient = {
        ...state.currentPatient,
        ...action.payload.data.currentPatient
      }
      const newPatients = [...state.patients]
      newPatients[index] = newCurrentPatient
      return {
        ...state,
        patients: newPatients,
        currentPatient: newCurrentPatient
      }

    case ActionTypes.set_current_patient_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case ActionTypes.get_reports_success:
      const { currentPatient } = state
      currentPatient.reports = action.payload.data.reports
      return {
        ...state,
        currentPatient
      }

    case ActionTypes.get_reports_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }
    case ActionTypes.add_report_success:
      const reports = state.currentPatient.reports
        ? [...state.currentPatient.reports, action.payload.data.report]
        : [action.payload.data.report]

      return {
        ...state,
        currentPatient: {
          ...state.currentPatient,
          reports
        }
      }

    case ActionTypes.add_report_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case ActionTypes.update_report:
      const allReports = state.currentPatient.reports

      allReports.map((report, i) => {
        if (i === action.payload.data.position) {
          if (!action.payload.data.report.signature) {
            report.text = action.payload.data.report.text
          } else {
            report.text = action.payload.data.report.text
            report.signature = action.payload.data.report.signature
            report.canvas = action.payload.data.report.canvas
          }
        }
      })

      return {
        ...state,
        currentPatient: {
          ...state.currentPatient,
          reports: allReports
        }
      }
    case ActionTypes.save_new_patient:
      patients.push(action.payload.data.patientDetails)
      return {
        ...state,
        patients
      }
    case ActionTypes.set_passed_base_form:
      return {
        ...state,
        currentPatient: {
          ...state.currentPatient,
          passedBaseForm: action.payload.data.passedBaseForm
        }
      }
    case ActionTypes.set_passed_games:
      return {
        ...state,
        currentPatient: {
          ...state.currentPatient,
          passedGames: action.payload.data.passedGames
        }
      }
    case ActionTypes.delete_child_success:
      const { id } = action.payload.data
      const filteredPatients = patients.filter(p => p.patientId !== id)
      return {
        ...state,
        patients: filteredPatients
      }
    case ActionTypes.clear:
      return { ...initState }

    case ActionTypes.set_curr_child: {
      const patient = action.payload.data
      const indexOfPatient = state.patients.findIndex(
        currPatient => currPatient.patientId === patient.patientId
      )
      const patientsArr = [...state.patients]
      patientsArr[indexOfPatient] = patient

      return {
        ...state,
        patients: patientsArr,
        currentPatient: patient
      }
    }
    case ActionTypes.set_questionnaries_in_row:
      return {
        ...state,
        questionnarie_is_in_row: action.payload.data
      }
    case ActionTypes.set_talents_chart_map:
      return {
        ...state,
        talentsChartData: action.payload.data
      }

    case ActionTypes.set_answers:
      const {
        formTypeData,
        formType: currentFormType,
        patientId
      }: ISetAnswersReduserParams = action.payload.data

      return merge(state, {
        questionsData: {
          [patientId]: {
            [currentFormType]: formTypeData
          }
        }
      })

    case ActionTypes.clear_answers:
      const { currentPatientId, formType } = action.payload.data
      delete state.questionsData[currentPatientId][formType]

      return {
        ...state
      }

    case ActionTypes.set_current_assessment:
      const { childId, currentAssessmentTimestamp } = action.payload.data
      const patientIndex = patients.map(p => p.patientId).indexOf(childId)

      if (patientIndex > -1) {
        patients[patientIndex].currentAssessment = currentAssessmentTimestamp
      } else {
        console.error(
          '[set_current_assessment]: patient not found by id',
          childId
        )
      }

      console.log('[set_current_assessment]:', currentAssessmentTimestamp)

      return {
        ...state,
        patients
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/patients/index.ts